import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuDivider,
  DropdownMenuItem,
  DropdownMenuTrigger
} from "@certa/catalyst/components/Dropdown";
import { CornerArrowBottorRight } from "@certa/icons/components/CornerArrowBottorRight";
import { Fragment } from "react";
import { useNavigate } from "react-router";
import type {
  BreadcrumbDropdownProps,
  BreadcrumbLink
} from "../Breadcrumb.types";
import styles from "./BreadcrumbDropdown.module.css";

const BreadcrumbDropdown = ({
  links,
  onLinkClick,
  menuWidth
}: BreadcrumbDropdownProps) => {
  const navigate = useNavigate();

  const onRedirect = (link: BreadcrumbLink) => {
    if (link.url) {
      navigate(link.url);
    }
    if (link.onClick) {
      link.onClick();
    }
    onLinkClick?.();
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger>
        <button
          className={styles.breadcrumbDropdownTriggerButton}
          aria-label="View more links"
        >
          <span className={styles.dotsWrapper}>&#8230;</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent width={menuWidth}>
        <Fragment>
          {links.map((link, index) => (
            <Fragment key={index}>
              <DropdownMenuItem
                onSelect={() => onRedirect(link)}
                value={link.label}
              >
                {index > 0 && <CornerArrowBottorRight />}
                {link.label}
              </DropdownMenuItem>
              {index < links.length - 1 && (
                <DropdownMenuDivider
                  className={styles.dropdownMenuItemSeparator}
                />
              )}
            </Fragment>
          ))}
        </Fragment>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export { BreadcrumbDropdown };
